import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class DespesaService {
	private data = null;
	private url = environment.serviceApi;
	// ids
	private manutencao_id = 1;
	private combustivel_id = 2;
	private ipva_id = 3;
	private seguro_id = 4;
	// unidades de medida
	private manutencao_un = 1;
	private combustivel_un = 1;
	private ipva_un = 1;
	private seguro_un = 1;

	constructor(public http: Http) { }

	getDespesas(tipo=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/despesas' + (tipo? '/porTipo/' + tipo : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getManutencao() {
		return this.getDespesas(this.manutencao_id);
	}

	getCombustivel() {
		return this.getDespesas(this.combustivel_id);
	}

	getIpva() {
		return this.getDespesas(this.ipva_id);
	}

	getSeguro() {
		return this.getDespesas(this.seguro_id);
	}

	getDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/despesas/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/despesas', {
				usuario_id: data.usuario_id,
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				veiculo_id: data.veiculo_id,
				fornecedor_id: data.fornecedor_id,
				despesa_planejado: data.despesa_planejado,
				despesa_quantidade: data.despesa_quantidade,
				despesa_valor: data.despesa_valor,
				despesa_data_compra: data.despesa_data_compra,
				despesa_descricao: data.despesa_descricao,
				despesa_situacao: data.despesa_situacao,
				despesa_solicitante: data.despesa_solicitante,
				despesa_aprovador: data.despesa_aprovador,
				grupo_despesa_id: data.grupo_despesa_id,
				posto_id: data.posto_id,
				flag_tipo_combustivel: data.tipo_combustivel_id,
				despesa_solicitante_id: data.despesa_solicitante_id,
				despesa_valor_licenciamento: data.despesa_valor_licenciamento,
				despesa_valor_seguro: data.despesa_valor_seguro
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaManutencao(data) {
		let newData = data;
		newData.tipo_despesa_id = this.manutencao_id;
		newData.unidade_medida_id = this.manutencao_un;
		return this.criaDespesa(newData);
	}

	criaCombustivel(data) {
		let newData = data;
		newData.tipo_despesa_id = this.combustivel_id;
		newData.unidade_medida_id = this.combustivel_un;
		return this.criaDespesa(newData);
	}

	criaIpva(data) {
		let newData = data;
		newData.tipo_despesa_id = this.ipva_id;
		newData.unidade_medida_id = this.ipva_un;
		return this.criaDespesa(newData);
	}

	criaSeguro(data) {
		let newData = data;
		newData.tipo_despesa_id = this.seguro_id;
		newData.unidade_medida_id = this.seguro_un;
		return this.criaDespesa(newData);
	}

	editaDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/despesas/' + data.despesa_id, {
				usuario_id: data.usuario_id,
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				veiculo_id: data.veiculo_id,
				fornecedor_id: data.fornecedor_id,
				despesa_planejado: data.despesa_planejado,
				despesa_quantidade: data.despesa_quantidade,
				despesa_valor: data.despesa_valor,
				despesa_data_compra: data.despesa_data_compra,
				despesa_descricao: data.despesa_descricao,
				despesa_situacao: data.despesa_situacao,
				despesa_solicitante: data.despesa_solicitante,
				despesa_aprovador: data.despesa_aprovador,
				grupo_despesa_id: data.grupo_despesa_id,
				posto_id: data.posto_id,
				flag_tipo_combustivel: data.tipo_combustivel_id,
				despesa_solicitante_id: data.despesa_solicitante_id,		
				despesa_valor_licenciamento: data.despesa_valor_licenciamento,
				despesa_valor_seguro: data.despesa_valor_seguro						
				
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaManutencao(data) {
		let newData = data;
		newData.tipo_despesa_id = this.manutencao_id;
		newData.unidade_medida_id = this.manutencao_un;
		return this.editaDespesa(newData);
	}

	editaCombustivel(data) {
		let newData = data;
		newData.tipo_despesa_id = this.combustivel_id;
		newData.unidade_medida_id = this.combustivel_un;
		return this.editaDespesa(newData);
	}

	editaIpva(data) {
		let newData = data;
		newData.tipo_despesa_id = this.ipva_id;
		newData.unidade_medida_id = this.ipva_un;
		return this.editaDespesa(newData);
	}

	editaSeguro(data) {
		let newData = data;
		newData.tipo_despesa_id = this.seguro_id;
		newData.unidade_medida_id = this.seguro_un;
		return this.editaDespesa(newData);
	}

	apagaDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/despesas/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getByUsuarioAndTipo(usuario_id, tipo_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/despesas/'+ usuario_id + '/' + tipo_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});

	}

	getByDespesaAndTipoQtd(usuario_id, tipo_id, filtro) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/despesas/despesa_qtd/'+ usuario_id + '/' + tipo_id + params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});

	}

	getByDespesaAndTipoConsulta(usuario_id, tipo_id,  filtro={}, pagina=1){
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/despesas/despesa_consulta/'+ usuario_id + '/' + tipo_id + '/' + pagina + params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});		


	}

}
